import { Component, Input } from '@angular/core';

/**
 * Just wraps the Angular Material progress bar to provide a convenient way
 * to supply a loading bar to many components without re-adjusting the layout
 */
@Component({
    selector: 'app-loadbar',
    template: `
    <div class="loadbar">
      <div *ngIf="loading" class="loadbar-animation"></div>
    </div>
  `,
    standalone: false
})
export class AppLoadbar {

  @Input() public loading: boolean;

}
